import React, { useState, useEffect } from "react";
import { AddOwnerModal } from "./component/AddOwnerModal";
import NewLoader from "../../components/styled-components/loader/NewLoader";
import menuIcon from "../../assets/images/DeathModuleNew/Menu.png";
import { MODULE_API } from "../../apis";
import FETCH from "../../utils/fetch";
import { Table } from "antd";
import swal from "sweetalert";

export const ManageOwner = () => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [ownerList, setOwnerList] = useState([]);
  const userRole =
    localStorage.getItem("role") != "undefined" &&
    JSON.parse(localStorage.getItem("role"));
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [cachedData, setCachedData] = useState({});

  const handlechange = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setFormData(null);
  };

  const getSelectedRow = (id) => {
    setSelectedIndex(id);
  };
  const updateStateWithData = (datares) => {
    if (datares && datares.records) {
      setOwnerList(datares.records);
    }
    if (datares && datares.pagination) {
      setTotalPages(
        Math.ceil(datares.pagination.total / datares.pagination.limit)
      );
    }
  };

  const getOwnersDetails = async (page) => {
    if (cachedData && cachedData[page]) {
      // Use cached data
      setLoading(false);
      updateStateWithData(cachedData[page]);
      return;
    }
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Owners and Entities&page=${page}&limit=10&clientId=${ID}`
            : `?module=Owners and Entities&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setAssetsList(datares.records);
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error while fetching tax credit", error);
    }
  };
  const getOwnersDetailsAfterDelete = async (page) => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id:
          userRole === "Financial Advisor Client"
            ? `?module=Owners and Entities&page=${page}&limit=10&clientId=${ID}`
            : `?module=Owners and Entities&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        // setAssetsList(datares.records);
        // Cache the data for the current page
        setCachedData((prevState) => ({
          ...prevState,
          [page]: datares,
        }));
        updateStateWithData(datares);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const deleteOwnerDetails = async (id) => {
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });

          setOwnerList([]);
          await getOwnersDetailsAfterDelete(1);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };
  const handleSave = async () => {
    setIsModalOpen(false);
    if (formData && !formData.id) {
      try {
        let payload = {
          ...formData,
        };

        setLoading(true);
        let data = await MODULE_API.addAsset("Owners and Entities", {
          clientModules: [{ ...payload }],
        });
        console.log("datataa", data);
        if (data && data.statusCode === 201) {
          swal("Success", "Owner Details Added Successfuly", "success");
          await getOwnersDetails(1);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let payload = {
          ...formData,
        };

        let data = await MODULE_API.updateClientModule(formData.id, {
          ...payload,
        });
        if (data && data.status === 200) {
          swal("Success", "Owner Detail Updated Successfully.", "success");
          await getOwnersDetailsAfterDelete(1);
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    setFormData(null);
  };

  useEffect(() => {
    getOwnersDetails(1);
  }, []);

  const cols = [
    {
      title: "Name",
      dataIndex: "Name",
      key: "name",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Type",
      dataIndex: "Type",
      key: "type",
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        return (
          <React.Fragment>
            <div style={{ display: "flex",position:"relative" }} key={index}>
              <div
                onClick={() => {
                  getSelectedRow(record.id);
                  setDropdown(!dropdown);
                }}
                style={{
                  cursor: "pointer",
                  marginRight: "1rem",
                  padding: "0px 16px",
                  width: "5px",
                }}
              >
                <img src={menuIcon} alt="menuIcon" height={15} width={4}></img>{" "}
              </div>
              {dropdown && selectedIndex === record.id && (
                <React.Fragment>
                  <div
                    onClick={() => {
                      setDropdown(false);
                    }}
                    className="table-menu-open"
                  ></div>

                  <div
                    class="dropdown"
                    style={{
                      zIndex: "9999",
                      left: "6%",
                      right: "0%",
                      width: "120px",
                      top:"1rem",
                    }}
                  >
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          setIsModalOpen(true);
                          setFormData(record);
                        }}
                      >
                        Update
                      </li>

                      <li
                        className="liHover"
                        onClick={() => {
                          setDropdown(false);
                          deleteOwnerDetails(record.id);
                        }}
                      >
                        Delete
                      </li>
                    </ul>
                  </div>
                </React.Fragment>
              )}{" "}
            </div>
          </React.Fragment>
        );
      },
    },
  ];

  return (
    <div className="profileMain">
      <div className="addbudgetSection">
        <div className="addTitle">Manage Owners & Entities</div>
        <button
          className="addbuttonassets"
          onClick={() => {
            setIsModalOpen(true);
          }}
        >
          {" "}
          + Add Owners & Entities
        </button>
      </div>
      <div className="inputTitle" style={{ margin: "1rem 0px", width: "60%" }}>
        Add any person (e.g., ‘John Smith’), group (‘John & Jane Smith’), or
        legal entity (‘Smith Family Trust’) that owns an asset or liability.
        This list will appear in dropdown menus throughout the platform.
      </div>
      {isModalOpen && (
        <AddOwnerModal
          title={
            formData && formData.id
              ? "Update Owner Details"
              : "Add Owner Details"
          }
          open={isModalOpen}
          handleChange={handlechange}
          handleCancel={handleCancel}
          data={formData && formData}
          handleSave={handleSave}
        />
      )}
      <div style={{ position: "relative", marginTop: "2rem" }}>
        <Table
          columns={cols}
          dataSource={ownerList && ownerList}
          pagination={{
            total: totalPages * 10, // Assuming 10 items per page
            current: currentPage,
            onChange: (page) => {
              setCurrentPage(page);
            },
            pageSize: 10, // Number of items per page
          }}
        />
        <NewLoader isLoading={loading} />
      </div>
    </div>
  );
};
